import { render, staticRenderFns } from "./defaultLayout.vue?vue&type=template&id=f261071c&"
import script from "./defaultLayout.vue?vue&type=script&lang=ts&"
export * from "./defaultLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports